/* ============================================================
   Shop The Look — product page
   Standalone: only loaded by snippets/shop-the-look.liquid

   Moves the block under its accordion mount, runs the slider, and
   quick-adds to the cart the same way Prestige's own product form
   does so the cart drawer refreshes instead of throwing.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    /* ---------- move it under the accordions ---------- */
    var mount = document.querySelector('[data-shop-look-mount="' + root.dataset.blockId + '"]');
    if (mount && root.parentElement !== mount) mount.appendChild(root);

    /* ---------- slider ---------- */
    var viewport = root.querySelector('[data-shop-look-viewport]');
    var prevButton = root.querySelector('[data-shop-look-prev]');
    var nextButton = root.querySelector('[data-shop-look-next]');
    var page = 0;

    // cards per view changes with the breakpoint, so measure rather than assume
    function pageCount() {
      return Math.max(1, Math.ceil(viewport.scrollWidth / Math.max(1, viewport.clientWidth)));
    }

    function hasPages() {
      return viewport.scrollWidth - viewport.clientWidth > 1;
    }

    function goTo(next) {
      // wraps around so both arrows always do something
      var pages = pageCount();
      page = (next + pages) % pages;
      viewport.scrollTo({ left: page * viewport.clientWidth, behavior: 'smooth' });
    }

    if (viewport && hasPages()) {
      if (prevButton) prevButton.addEventListener('click', function () { goTo(page - 1); });
      if (nextButton) nextButton.addEventListener('click', function () { goTo(page + 1); });
    } else {
      // nothing to scroll to: drop the arrows rather than leave them inert
      if (prevButton) prevButton.remove();
      if (nextButton) nextButton.remove();
    }

    var scrollTimer;
    if (viewport) {
      viewport.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          page = Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth));
        }, 80);
      }, { passive: true });

      window.addEventListener('resize', function () {
        viewport.scrollTo({ left: page * viewport.clientWidth, behavior: 'auto' });
      }, { passive: true });
    }

    /* ---------- variant select (only when Single variant is off) ---------- */
    root.querySelectorAll('[data-shop-look-variant]').forEach(function (select) {
      select.addEventListener('change', function () {
        var card = select.closest('[data-shop-look-card]');
        var selected = select.options[select.selectedIndex];
        var price = card.querySelector('[data-shop-look-price]');
        var button = card.querySelector('[data-shop-look-submit]');

        if (price) {
          price.innerHTML = selected.dataset.comparePrice
            ? '<span class="shop-the-look__sale-price">' + selected.dataset.price + '</span><s>' + selected.dataset.comparePrice + '</s>'
            : '<span>' + selected.dataset.price + '</span>';
        }

        if (button) button.disabled = selected.dataset.available !== 'true';
      });
    });

    /* ---------- quick add ---------- */
    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.show === 'function') return drawer.show();
      if (drawer && typeof drawer.open === 'function') return drawer.open();

      var trigger = document.querySelector('[aria-controls="cart-drawer"], [data-action="open-drawer"][aria-controls*="cart"]');
      if (trigger) return trigger.click();

      window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    }

    root.querySelectorAll('[data-shop-look-form]').forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        var button = form.querySelector('[data-shop-look-submit]');
        var error = form.querySelector('[data-shop-look-error]');
        var variantInput = form.querySelector('[name="id"]');

        if (!variantInput || !variantInput.value || (button && button.disabled)) return;

        if (button) {
          button.classList.add('is-loading');
          button.disabled = true;
        }
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }

        try {
          var root_url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

          // Prestige's cart drawer re-renders itself from cart.sections[<its id>],
          // so the add request has to bundle the same sections its own product-form
          // asks for. Without this it throws on an undefined `sections`.
          var sectionsToBundle = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          }));

          var body = new FormData();
          body.set('id', variantInput.value);
          body.set('quantity', '1');
          body.set('sections', sectionsToBundle.join(','));
          body.set('sections_url', root_url + 'variants/' + variantInput.value);

          var response = await fetch(root_url + 'cart/add.js', {
            method: 'POST',
            body: body,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          var addedItem = await response.json();
          if (!response.ok) {
            throw new Error(addedItem.description || addedItem.message || 'Unable to add this product.');
          }

          var cart = await (await fetch(root_url + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          cart.sections = addedItem.sections;

          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: addedItem.items || [addedItem], cart: cart }
          }));

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cart }
          }));

          openCartDrawer();
        } catch (addError) {
          if (error) {
            error.textContent = addError.message;
            error.hidden = false;
          }
        } finally {
          if (button) {
            button.classList.remove('is-loading');
            button.disabled = false;
          }
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.shop-the-look').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('.shop-the-look');
    if (el) init(el);
  });
})();
